import { Form } from './style';

export default Form;
